export const DEFAULT_INTELLEXUS_DATE: IntellexusDateStructure = {
  ranges: [],
  selected_index: null,
  selected_date: {
    from: null,
    to: null,
    certainty_from: null,
    certainty_to: null,
  },
};

export interface IntellexusDateEntry {
  from: string; // Date de début ou limite inférieure
  to: string; // Date de fin ou limite supérieure
  selected: boolean; // Indique si cette date est sélectionnée
}

export interface IntellexusDateStructure {
  ranges: IntellexusDateRange[];
  selected_index: number | null;
  selected_date: SelectedIntellexusDate;
}

export interface SelectedIntellexusDate {
  from: number | null;
  to: number | null;
  certainty_from: boolean | null;
  certainty_to: boolean | null;
}

export interface IntellexusDateRange {
  from: string[];
  to: string[];
  certainty_from: boolean[];
  certainty_to: boolean[];
}

export interface IntellexusDateProps {
  data: IntellexusDateStructure;
  onChange: (updated: IntellexusDateStructure) => void;
  label?: string;
}
